/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import UserService from "../../services/UserService";
import { If } from "../../utils/Controls";
import { AntdPaging, AntdTag } from "../../utils/Antd";
import util from "../../utils/util";
import Tabs, { PageHeading } from "./Tabs";
import edit from "../assets/icons/pen-to-square-solid.svg";
import xmark from "../assets/icons/circle-xmark-solid.svg";
import { trailCreate, trailUpdate, trailDelete, TRAIL_MODULES } from '../../utils/activityTrail';
import { Input, Button, message, Modal, Divider, Checkbox, Switch, Tooltip } from 'antd';
import { ExclamationCircleOutlined, EyeOutlined, PlusOutlined, EditOutlined, DeleteOutlined, ExportOutlined } from '@ant-design/icons';
const { confirm } = Modal;

const PERM_COLS = [
    { key: 'view',   label: 'View',   icon: <EyeOutlined/>,    color: '#1890ff' },
    { key: 'add',    label: 'Add',    icon: <PlusOutlined/>,   color: '#52c41a' },
    { key: 'edit',   label: 'Edit',   icon: <EditOutlined/>,   color: '#fa8c16' },
    { key: 'delete', label: 'Delete', icon: <DeleteOutlined/>, color: '#f5222d' },
    { key: 'export', label: 'Export', icon: <ExportOutlined/>, color: '#722ed1' },
];

export default function Role() {
    const [result, setResult] = useState({ data: [], page: {} });
    const [modules, setModules] = useState([]);
    const sdataRef = useRef({ p: 1, ps: 25 });
    const formRef = useRef();

    const list = (p, ps) => {
        sdataRef.current.p = p || 1;
        sdataRef.current.ps = ps || sdataRef.current.ps;
        util.showLoader();
        UserService.roles(sdataRef.current).then(({ data }) => {
            setResult(data.result);
        }).catch(e => {
            message.error(e.message);
        }).finally(() => {
            util.hideLoader();
        });
    };

    const deleteRecord = (id) => {
        message.destroy();
        confirm({
            title: 'Do you Want to delete this role?',
            icon: <ExclamationCircleOutlined />,
            okText: 'Yes', okType: 'danger', cancelText: 'No',
            onOk() {
                util.showLoader();
                UserService.deleteRole(id).then(({ data: delData }) => {
                    message.success(delData.message || 'Deleted');
                    const role = result.data.find(r => r.id === id);
                    trailDelete(TRAIL_MODULES.USER_MANAGEMENT, `Role: ${role?.title || id}`, id);
                    list();
                }).catch(e => {
                    message.error(e.message);
                }).finally(() => {
                    util.hideLoader();
                });
            },
        });
    };

    useEffect(() => {
        list();
        UserService.modules().then(res => setModules([...res.data.data]));
        return () => { message.destroy(); };
    }, []);

    return (
        <div className="page-content">
            <div className="page-head uc d-flex">
                <div className="my-auto"><PageHeading /></div>
                <div className="my-auto ml-auto"></div>
            </div>
            <div className="page-pad">
                <div className="tabbable-custom">
                    <Tabs active="roles" />
                    <div className="tab-content">
                        <div className="tab-pane fade1 show active">
                            {result.data.length > 0 && (
                                <div className="text-secondary mb8">
                                    Showing {result.page.start + 1} - {result.page.start + result.page.total} of {result.page.total_records} records.
                                </div>
                            )}
                            <div className="d-flex tbl-search-head">
                                <div className="my-auto"><SearchForm dataRef={sdataRef} onSearch={list} /></div>
                                <div className="ml-auto my-auto">
                                    <Button type="primary" onClick={() => formRef.current.openForm()}>
                                        <i className="fa fa-plus mr5"></i> Add User Role
                                    </Button>
                                </div>
                            </div>
                            <If cond={result.data.length}>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-md table-striped table-hover m-0">
                                        <thead className="thead-light text-uppercase table-text-vmid">
                                            <tr>
                                                <th className="w20">SN</th>
                                                <th>Role Name</th>
                                                <th className="w60">Status</th>
                                                <th className="w70"></th>
                                            </tr>
                                        </thead>
                                        <tbody className="table-text-top">
                                            {result.data.map((v, i) => (
                                                <tr key={i}>
                                                    <td>{result.page.start + i + 1}.</td>
                                                    <td>{v.title}</td>
                                                    <td className="nowrap">
                                                        {v.status
                                                            ? <AntdTag type="success">Active</AntdTag>
                                                            : <AntdTag type="danger">Inactive</AntdTag>}
                                                    </td>
                                                    <td className="text-center">
                                                        <Button.Group size="small">
                                                            <Button type="default" disabled={v.id * 1 < 3} onClick={() => formRef.current.openForm(v)}>
                                                                <img src={edit} alt='' className='mr5' height={15} />
                                                            </Button>
                                                            <Button type="default" disabled={v.id * 1 < 3} onClick={() => deleteRecord(v.id)}>
                                                                <img src={xmark} alt='' className='mr5' height={15} />
                                                            </Button>
                                                        </Button.Group>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="d-flex tbl-foot-bx">
                                    <AntdPaging
                                        onChange={list}
                                        total={result.page.total_records}
                                        current={result.page.cur_page}
                                        pageSize={sdataRef.current.ps}
                                        showSizeChanger
                                    />
                                </div>
                            </If>
                            <If cond={!result.data.length}>
                                <div className="no-rec">No record found</div>
                            </If>
                        </div>
                    </div>
                </div>
            </div>
            <AddForm ref={formRef} callback={list} pageno={sdataRef.current.p} modules={modules} />
        </div>
    );
}

const SearchForm = ({ dataRef, onSearch }) => {
    const [data, setData] = useState({ ...dataRef.current });
    useEffect(() => { dataRef.current = { ...data }; }, [data]);
    useEffect(() => { setData(d => ({ ...d, p: dataRef.current.p, ps: dataRef.current.ps })); }, [dataRef.current.p, dataRef.current.ps]);
    return (
        <form onSubmit={e => e.preventDefault()} autoComplete="off">
            <div className="d-flex">
                <Input placeholder="Search" allowClear value={data.k} onChange={e => setData(d => ({ ...d, k: e.target.value }))} />
                <Button type="primary" icon={<i className="fa fa-search fs13" />} onClick={() => onSearch()} />
            </div>
        </form>
    );
};

const AddForm = forwardRef((props, ref) => {
    const { callback, pageno, modules } = props;
    const [showForm, setShowForm] = useState(false);
    const [data, setData] = useState(null);
    const [permissions, setPermissions] = useState({});
    const [loadingPerms, setLoadingPerms] = useState(false);
    const isNational = util.isNational();

    const handleChange = (v, k) => setData(d => ({ ...d, [k]: v }));

    // Toggle a module on/off — store key strings (not IDs) to match DB format
    const toggleModule = (moduleId, moduleKey, checked) => {
        setData(d => {
            const ids = d.app_modules || [];
            // Support both string keys and numeric IDs
            const newIds = checked
                ? [...ids, moduleKey]
                : ids.filter(x => x !== moduleKey && x !== moduleId);
            return { ...d, app_modules: newIds };
        });
        if (checked && !permissions[moduleKey]) {
            setPermissions(p => ({ ...p, [moduleKey]: { view:1, add:0, edit:0, delete:0, export:0 } }));
        }
        if (!checked) {
            setPermissions(p => { const n={...p}; delete n[moduleKey]; return n; });
        }
    };

    const togglePerm = (moduleKey, action, val) => {
        setPermissions(p => ({
            ...p,
            [moduleKey]: { ...(p[moduleKey]||{view:1,add:0,edit:0,delete:0,export:0}), [action]: val ? 1 : 0 }
        }));
    };

    const setAllPerms = (moduleKey, val) => {
        setPermissions(p => ({
            ...p,
            [moduleKey]: { view:val?1:0, add:val?1:0, edit:val?1:0, delete:val?1:0, export:val?1:0 }
        }));
    };

    const save = () => {
        message.destroy();
        util.showLoader();
        const payload = { ...data, permissions };
        UserService.saveRole(payload).then(({ data: savedData }) => {
            message.success(savedData.message || 'Saved');
            data.id
                ? trailUpdate(TRAIL_MODULES.USER_MANAGEMENT, `Role: ${data.title}`, data.id, { moduleCount: data.app_modules?.length })
                : trailCreate(TRAIL_MODULES.USER_MANAGEMENT, `Role: ${data.title}`, '', { moduleCount: data.app_modules?.length });
            callback(savedData.id ? pageno : 1);
            setShowForm(false);
        }).catch(e => message.error(e.message))
          .finally(() => util.hideLoader());
    };

    const saveRoleForAllClients = () => {
        message.destroy();
        util.showLoader();
        UserService.saveRoleForAllClients({ ...data, permissions }).then(({ data: savedData }) => {
            message.success(savedData.message || 'Saved');
            callback(savedData.id ? pageno : 1);
            setShowForm(false);
        }).catch(e => message.error(e.message))
          .finally(() => util.hideLoader());
    };

    useImperativeHandle(ref, () => ({
        openForm(dtl) {
            setData(dtl ? { ...dtl } : { app_modules: [], status: '1' });
            setPermissions({});
            if (dtl?.id) {
                setLoadingPerms(true);
                UserService.getRolePermissions(dtl.id)
                    .then(r => setPermissions(r.data?.data || {}))
                    .catch(() => {})
                    .finally(() => setLoadingPerms(false));
            }
            setShowForm(true);
        }
    }));

    // Group modules by group_id for display
    const grouped = modules.reduce((acc, m) => {
        const g = m.group_name || m.group_id || 'Other';
        if (!acc[g]) acc[g] = [];
        acc[g].push(m);
        return acc;
    }, {});

    const isModuleEnabled = (moduleId, moduleKey) => {
        const mods = data?.app_modules || [];
        return mods.includes(moduleKey) || mods.includes(moduleId) || mods.includes(String(moduleId));
    };

    return (
        <Modal
            title={<span style={{ fontWeight:800 }}>{data?.id ? 'Edit' : 'Add'} Role</span>}
            open={showForm}
            onCancel={() => setShowForm(false)}
            destroyOnClose
            maskClosable={false}
            width={1100}
            footer={[
                <Button key="back" onClick={() => setShowForm(false)}>Cancel</Button>,
                isNational && (
                    <Button key="saveForAll" type="default" onClick={saveRoleForAllClients}>
                        Save For All
                    </Button>
                ),
                <Button key="submit" type="primary" onClick={save}>Save</Button>
            ]}
        >
            {data !== null && (
                <div>
                    <div className="row mingap" style={{ marginBottom:16 }}>
                        <div className="col-md-6">
                            <label className="req" style={{ fontWeight:600 }}>Role Name</label>
                            <Input value={data.title || ''} onChange={e => handleChange(e.target.value, 'title')} />
                        </div>
                    </div>

                    <Divider orientation="left" style={{ fontWeight:700, color:'#1f3864' }}>
                        Module Access & Permissions
                    </Divider>

                    {loadingPerms && <div style={{ textAlign:'center', padding:20, color:'#888' }}>Loading permissions…</div>}

                    {!loadingPerms && (
                        <div style={{ overflow:'auto', maxHeight:'55vh', border:'1px solid #e8e8e8', borderRadius:4 }}>
                            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:12 }}>
                                <thead>
                                    <tr style={{ background:'#1f3864' }}>
                                        <th style={{ padding:'8px 12px', color:'#fff', textAlign:'left', minWidth:200, position:'sticky', top:0, background:'#1f3864', zIndex:2 }}>Module</th>
                                        <th style={{ padding:'8px 12px', color:'#fff', textAlign:'center', width:60, position:'sticky', top:0, background:'#1f3864', zIndex:2 }}>Enable</th>
                                        {PERM_COLS.map(col => (
                                            <th key={col.key} style={{ padding:'8px 12px', color:'#fff', textAlign:'center', width:70, position:'sticky', top:0, background:'#1f3864', zIndex:2 }}>
                                                <Tooltip title={col.label}>
                                                    <span style={{ color: col.color, fontSize:14 }}>{col.icon}</span>
                                                </Tooltip>
                                                <div style={{ fontSize:10, marginTop:2 }}>{col.label}</div>
                                            </th>
                                        ))}
                                        <th style={{ padding:'8px 12px', color:'#fff', textAlign:'center', width:80, position:'sticky', top:0, background:'#1f3864', zIndex:2 }}>All</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.entries(grouped).map(([groupName, groupModules]) => (
                                        <React.Fragment key={groupName}>
                                            <tr style={{ background:'#f0f5ff' }}>
                                                <td colSpan={7} style={{ padding:'6px 12px', fontWeight:700, fontSize:11, color:'#1f3864', letterSpacing:1, textTransform:'uppercase' }}>
                                                    {groupName}
                                                </td>
                                            </tr>
                                            {groupModules.map((m, i) => {
                                                const mKey     = m.key || String(m.id);
                                                const enabled  = isModuleEnabled(m.id, mKey);
                                                const perms    = permissions[mKey] || { view:0, add:0, edit:0, delete:0, export:0 };
                                                const allOn    = PERM_COLS.every(c => perms[c.key] === 1);
                                                return (
                                                    <tr key={m.id} style={{ background: i%2 ? '#fafafa':'#fff', opacity: enabled ? 1 : 0.5 }}>
                                                        <td style={{ padding:'7px 12px', fontWeight:600 }}>{m.name}</td>
                                                        <td style={{ padding:'7px 12px', textAlign:'center' }}>
                                                            <Switch
                                                                size="small"
                                                                checked={enabled}
                                                                onChange={v => toggleModule(m.id, mKey, v)}
                                                            />
                                                        </td>
                                                        {PERM_COLS.map(col => (
                                                            <td key={col.key} style={{ padding:'7px 12px', textAlign:'center' }}>
                                                                <Checkbox
                                                                    disabled={!enabled}
                                                                    checked={enabled && perms[col.key] === 1}
                                                                    onChange={e => togglePerm(mKey, col.key, e.target.checked)}
                                                                />
                                                            </td>
                                                        ))}
                                                        <td style={{ padding:'7px 12px', textAlign:'center' }}>
                                                            <Checkbox
                                                                disabled={!enabled}
                                                                checked={enabled && allOn}
                                                                onChange={e => setAllPerms(mKey, e.target.checked)}
                                                                style={{ fontSize:10 }}
                                                            >
                                                                <span style={{ fontSize:10 }}>All</span>
                                                            </Checkbox>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            )}
        </Modal>
    );
});